export default 'GAS';
